<template>
	<div>

		<Form ref="form" :model="modalformValidata" :label-width="150" label-position="right">
			<Row type="flex" justify="center" align="middle">
				<Col :span="6">
				<FormItem label="角色Code：" prop="roleCode">
					<Select v-model="modalformValidata.roleCode" placeholder="请选择权限" :label-in-value="true">
						<Option v-for="(item,index)  in baseRoleCodeData" :value="item.dictValue"
							:label="item.dictName" :key="index">{{item.dictName}}
						</Option>
					</Select>
				</FormItem>
				</Col>
				<Col :span="6" class="ivu-text-right">
				<FormItem>
					<Button type="primary" @click="handleSubmit">查询</Button>
					<Button @click="handleReset('form')" style="margin-left: 20px">重置</Button>
				</FormItem>
				</Col>
			</Row>
		</Form>
		 
		<Table stripe :columns="columns1" :data="data1">
			<template slot="action" slot-scope="{ row, index }">
				<Button type="info" ghost size="small" style="margin-right: 5px"
					@click="locationEditMain(row)">编辑</Button>
				<Button type="error" ghost size="small" @click="locationDelMain(row)">删除</Button>
			</template>
		</Table>
		<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage" show-total
			show-elevator next-text="下一页" />
	</div>


</template>
<script>
	//分页的初始参数
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y',
		isHistory: 'N',
		roleCode: null,
	 
	};
	import {
		getDictList,
	    queryRoleCodesByLocation,
	 
	} from '@/network/index.js';
	export default {
		data() {
			return {
				columns1: [{
						title: '路径',
						key: 'locationId'
					},
					{
						title: '角色code',
						key: 'roleCode'
					},
					{
						title: '角色codeName',
						key: 'roleCodeName'
					},
					 
					 
				],
			 
				 
				data1: [],
				data: { //查询条件
					roleName: '',
					roleCode: '',
				}, 
				baseRoleCodeData: [],  
				pageTotal: 0,
				pageNum: 1,
				pageSize: 10,

				locationId: 0,
	            modalformValidata: {
	            	roleCode: '', 
	            },
 

			}
		},
		created() {
			this.initData(paramter);


		},
		methods: {


		  




			//页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;

				this.initData()
			},
			initData(paramter) {
				//获取角色权限
				let paramterTemp = {
					dictCode: 'base_role_code',
				};
				getDictList(paramterTemp).then(res => {
						this.baseRoleCodeData.push({
							dictValue: '99999',
							dictName: '请选择'
						});
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
				
							this.baseRoleCodeData.push({
								dictValue: res.data.obj.dataList[i].dictValue,
								dictName: res.data.obj.dataList[i].dictName
							});
						}
				
					})
					.catch(error => {});
					
					
                  queryRoleCodesByLocation().then(res => {
						 
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
				
							this.data1.push({
								locationId: res.data.obj.dataList[i].locationId,
								roleCode: res.data.obj.dataList[i].roleCode,
								roleCodeName: res.data.obj.dataList[i].roleCodeName
							});
						}
				
					})
					.catch(error => {});

			},





			//重置
			handleReset(name) {
				this.$refs[name].resetFields();
				paramter.roleCode = null; 
			},
			//查询提交
			handleSubmit() {
                debugger;
				if (this.modalformValidata.roleCode != null && this.modalformValidata.roleCode != '') {
					paramter.roleCode = this.modalformValidata.roleCode;
				}
				 

				queryRoleCodesByLocation(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								locationId: res.data.obj.dataList[i].locationId,
								roleCode: res.data.obj.dataList[i].roleCode,
								roleCodeName: res.data.obj.dataList[i].roleCodeName
							});
						}
					})
					.catch(error => {});
			},

			 
		},


	}
</script>

<style lang="scss" scoped>
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}


	#divcss5 {
		display: flex; //水平分布
		border: 1px dashed #ff0000;
		height: 30px;
		width: 100%;


	}

	.item {
		flex: 1; //等分
		text-align: center; //等分后居中
		font-size: 18px;
	}


	#head-logo {
		width: 200px;
		height: 200px;
		text-align: center;
		border-radius: 3px; //添加圆角
	}
</style>
